import { apiURL } from "../config/default";
import axios from "axios";

export const getFilteredProduct = (data) => async (dispatch) => {
  console.log(data);
  const dataToParse = JSON.parse(data);
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
      `${apiURL}get-filtered-data?page=${
        dataToParse.page ? dataToParse.page : 1
      }`,
      data,
      _config
    );
    return res.data;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
  }
};

export const getBrandFilteredProduct = (data) => async (dispatch) => {
  console.log(data);
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
      `${apiURL}get-brand-filtered-data`,
      data,
      _config
    );
    return res.data;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
  }
};
